"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _BaseClient2 = _interopRequireDefault(require("./BaseClient"));

var ConversationsClient =
/*#__PURE__*/
function (_BaseClient) {
  (0, _inherits2["default"])(ConversationsClient, _BaseClient);

  function ConversationsClient(getAccessToken) {
    var isProduction = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    (0, _classCallCheck2["default"])(this, ConversationsClient);
    return (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(ConversationsClient).call(this, getAccessToken, isProduction ? 'https://api.conversations.cimpress.io' : 'https://stg.api.conversations.cimpress.io'));
  }

  (0, _createClass2["default"])(ConversationsClient, [{
    key: "createConversation",
    value: function createConversation(subject, accountId, content, attachments) {
      var body = {
        subject: subject,
        participants: [{
          accountId: accountId
        }],
        initialMessage: {
          content: content,
          attachments: attachments
        }
      };
      return this.fetchWithAuth({
        endpointUrl: this.endpointUrl,
        method: 'POST',
        route: "api/v0/conversations",
        body: body
      });
    }
  }, {
    key: "setConversationSubscription",
    value: function setConversationSubscription(userId, conversationId) {
      var enable = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
      var conversationUrl = "".concat(this.endpointUrl, "/api/v0/conversations/").concat(conversationId);
      var body = {
        resourceUrl: conversationUrl,
        enabled: enable
      };
      return this.fetchWithAuth({
        endpointUrl: 'https://baywatch.trdlnk.cimpress.io',
        route: "v0/users/".concat(userId, "/subscriptions/").concat(encodeURIComponent(conversationUrl)),
        method: 'PUT',
        body: body
      });
    }
  }]);
  return ConversationsClient;
}(_BaseClient2["default"]);

exports["default"] = ConversationsClient;